import React from "react";
import "../App.css";

export function Pagination({ pageCount, pageNumber, onPageChange }) {
  const count = Number(pageCount) || 0;

  if (count <= 1) {
    return null;
  }

  const getVisiblePages = () => {
    const pages = new Set([1, count, pageNumber - 1, pageNumber, pageNumber + 1]);
    const visiblePages = Array.from(pages)
      .filter((page) => page >= 1 && page <= count)
      .sort((firstPage, secondPage) => firstPage - secondPage);

    return visiblePages.reduce((items, page, index) => {
      if (index > 0 && page - visiblePages[index - 1] > 1) {
        items.push(`gap-${page}`);
      }

      items.push(page);
      return items;
    }, []);
  };

  const goToPage = (nextPage) => {
    if (nextPage < 1 || nextPage > count || nextPage === pageNumber) {
      return;
    }

    onPageChange(nextPage);
  };

  return (
    <div className="pagination-bar" aria-label="Pagination">
      <span className="pagination-summary">Page {pageNumber} of {count}</span>
      <div className="join pagination-controls">
        <button
          type="button"
          className="join-item btn"
          aria-label="Go to previous page"
          disabled={pageNumber === 1}
          onClick={() => goToPage(pageNumber - 1)}
        >
          Previous
        </button>
        {getVisiblePages().map((page) => {
          if (typeof page === "string") {
            return <span key={page} className="join-item pagination-gap">...</span>;
          }

          return (
            <button
              key={page}
              type="button"
              onClick={() => goToPage(page)}
              className={`join-item btn${page === pageNumber ? " btn-active" : ""}`}
              aria-current={page === pageNumber ? "page" : undefined}
              aria-label={`Go to page ${page}`}
            >
              {page}
            </button>
          );
        })}
        <button
          type="button"
          className="join-item btn"
          aria-label="Go to next page"
          disabled={pageNumber === count}
          onClick={() => goToPage(pageNumber + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
